import { ROUTE_CASINO, ROUTE_LIVE_CASINO } from '~/components/router/constants.js';

const productNavRoutes = [
	'about',
	'responsible-gaming',
	'terms-and-conditions',
	'privacy_policy',
	'sportsbook',
	'live-betting',
	'shop',
	'promotions',
	'bonus',
	'payments',
	'virtuals',
	'user-feedback',
	'we-spin',
	'grytv',
	'thunderbite',
	'splash-tech'
]
	.map(i => `/${i}`)
	.concat([ROUTE_CASINO, ROUTE_LIVE_CASINO]);

export default productNavRoutes;
